import {
  call,
  delay,
  put,
  race,
  select,
  take,
  takeEvery,
} from 'redux-saga/effects'

import * as FeatureFlags from '@app/domain/feature-flags/feature-flags.rest'
import type { AppAction, AppState } from '@app/state'

import { ActionType, actions } from './state'

import type { AxiosResponse } from 'axios'

function* updateFeatureFlags() {
  const appState: AppState = yield select((a) => a)

  const request = yield call(() => FeatureFlags.getFeatureFlags())
  const response: AxiosResponse<FeatureFlags.IFeatureFlagsResponse> = yield call(
    request,
    appState.config.apiLocation,
    appState.auth.token,
  )
  if (response.status === 200) {
    yield put(actions.updateAllFeatureFlags(response.data.featureFlags))
  }
}

function* pollFeatureFlagsWorker() {
  while (true) {
    yield call(updateFeatureFlags)
    yield delay(5000)
  }
}

function* pollFeatureFlagsWatcher() {
  yield race([
    call(pollFeatureFlagsWorker),
    take(ActionType.SubscribeToFeatureFlags),
    take(ActionType.UnsubscribeToFeatureFlags),
  ])
}

function* updateFeatureFlag(action: AppAction) {
  const appState: AppState = yield select((a) => a)
  if (action.type === ActionType.UpdateFeatureFlag) {
    const request = yield call(() =>
      FeatureFlags.setFeatureFlag(action.featureFlagId, action.enabled),
    )
    const response: AxiosResponse<FeatureFlags.IFeatureFlagsResponse> = yield call(
      request,
      appState.config.apiLocation,
      appState.auth.token,
    )
    if (response.status === 200) {
      yield put(actions.updateAllFeatureFlags(response.data.featureFlags))
    }
  }
}

function* handleUpdateFeatureFlag() {
  yield takeEvery(ActionType.UpdateFeatureFlag, updateFeatureFlag)
}

function* handleSubscribeToFeatureFlags() {
  yield takeEvery(ActionType.SubscribeToFeatureFlags, pollFeatureFlagsWatcher)
}

export const sagas = {
  handleSubscribeToFeatureFlags,
  handleUpdateFeatureFlag,
  pollFeatureFlagsWatcher,
}
